import GallectionsEmptyState from './GallectionsEmptyState';
import GallectionsEmptyStateContainer from './GallectionsEmptyState.container';

export default GallectionsEmptyStateContainer(
  GallectionsEmptyState
);
